import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'https://apix.curesora.xyz';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  crossDomain: true,
  timeout: 10000, // 10 seconds
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Server responded with error status
      console.error('API Error:', {
        status: error.response.status,
        message: error.response.data?.message || 'An error occurred',
        url: error.config.url,
      });
    } else if (error.request) {
      // Request was made but no response received
      console.error('Network Error:', error.message);
      error.message = 'Network Error: Unable to connect to the server';
    } else {
      // Something happened in setting up the request
      console.error('Request Error:', error.message);
    }
    return Promise.reject(error);
  }
);

export const animeAPI = {
  getAll: () => api.get('/api/anime'),
  getById: (id) => api.get(`/api/anime/${id}`),
  getEpisodes: (id) => api.get(`/api/anime/${id}/episodes`),
  create: (data) => api.post('/api/admin/anime', data),
  update: (id, data) => api.put(`/api/admin/anime/${id}`, data),
  delete: (id) => api.delete(`/api/admin/anime/${id}`),
  addEpisode: (id, data) => api.post(`/api/admin/anime/${id}/episodes`, data),
};

export const authAPI = {
  login: (credentials) => api.post('/api/admin/login', credentials),
  verify: () => api.get('/api/admin/verify'),
};

export default api;
